import React from "react"
import { Button, Form, Spinner, Select } from "react-bootstrap"
import filterDateIcon from "../../../../../assets/images/filterDateIcon.svg"
import { DatePicker } from "antd"
import RefreshIcon from "@mui/icons-material/Refresh"
import { styled } from "styled-components"

export const ArchiveListHeader = ({
  handleDueSearch,
  allMembers,
  allArchiveTableData,
  searchfromDate,
  searchDueDate,
  handleFromDate,
  isLoading,
  refreshAllTracking,
  flagFilterData,
  setFlagFilterData
}) => {
  if (allArchiveTableData.length > 0) {
    let result = []
    allArchiveTableData?.forEach((element) => {
      result.push({ label: element.label, value: element.id })
    })
    allArchiveTableData = result
  }

  if (allMembers.length > 0) {
    let result = []
    allMembers?.forEach((element) => {
      result.push({ label: element.personname, value: element.trackinguserid })
    })
    allMembers = result
  }

  const FlagOptions = [
    { label: "Flag 1", id: "1", value: "Flag 1" },
    { label: "Flag 2", id: "2", value: "Flag 2" },
    { label: "Flag 3", id: "3", value: "Flag 3" },
  ]

  return (
    <>
      {allArchiveTableData.length > 0 && (
        <ArchiveHeaderView>
        <div className='d-flex gap-3 pb-2 align-items-center justify-content-between'>
          <div className='report_task_date_filter'>
            {/* <div className='date_filter_con'>
              {" "}
              <DatePicker
                suffixIcon={<img src={filterDateIcon} alt='Calendar' />}
                onChange={handleFromDate}
                selected={searchfromDate}
                name={searchfromDate}
                placeholder='From date'
                className='form-control search-control border-start-0 search_date_filter'
              />{" "}
            </div> */}
            {/* <div className='date_filter_con'>
              {" "}
              <DatePicker
                suffixIcon={<img src={filterDateIcon} alt='Calendar' />}
                onChange={handleDueSearch}
                selected={searchDueDate}
                name={searchDueDate}
                placeholder='To date'
                className='form-control search-control border-start-0 search_date_filter'
              />{" "}
            </div> */}
            
            <div className='d-flex gap-2 align-items-center'>
              {/* <span className='date_filter_text color-white'>Flag Filter</span> */}
              <Form.Select
                // className="select-options"
                size="sm"
                value={flagFilterData}
                onChange={(e) => setFlagFilterData(e.target.value)}
                  className='form-control search-control border-start-0 search_date_filter'
              >
                <option value="">Select</option>
                {FlagOptions?.map((item, index) => (
                  <option value={item.value} key={index}>
                    {item.label}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>

            <Button
              className='me-1 btn-rad refresh_btn'
              onClick={(e) => {
                refreshAllTracking()
              }}
            >
              {isLoading ? (
                <Spinner size='sm' variant='light' animation='border' />
              ) : (
                <RefreshIcon />
              )}
            </Button>
        </div>
        </ArchiveHeaderView>
      )}
    </>
  )
}

const ArchiveHeaderView = styled.div`
  .refresh_btn {
    padding: 0px 0px;
    background-color: #4eb6ee;
    border-color: #4eb6ee;
    width: 28px;
    height: 28px;
    color: #ffffff;
  }
  .date_filter_text{
    color: #ffffff;
  }
  .search_date_filter{
    border: 1px solid #fff;
  }
`
